<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('profile')}}</h6>
                                <h1 class="header-title">{{$t('Details')}}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <navigation></navigation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Navigation from './Navigation'

export default {

    components: {
        Navigation
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapGetters('users', {
            getUserById: 'get'
        }),
        'user.birthDate': {
            get: () => {
                return this.birthDate;
            },
            set: (newValue) => {
                this.birthDate = '2014-09-12';
            }
        }
    },
    created() {
        this.getUser(this.user._id);
    },

    methods: {
        ...mapActions('users', {
            getUser: 'get',
            updateUser: 'patch'
        }),
        useImage(image) {
            this.user.avatar_id = image._id;
            this.user.avatar = image;
            // this.updateUser([this.user._id, this.user, {}]);

        },
        updateProfile() {
            this.updateUser([this.user._id, this.user, {}]).then(result => {

            });

        }
    },
}
</script>
